import React, { Fragment } from 'react';
import { useConfirmDialog } from './use-confirm-dialog';
import { useStyles } from './styles';

export const useConfirmDialogWithImage = (props) => {
  const classes = useStyles();

  const newContent = (
    <Fragment>
      {props.content}
      <div className={classes.imageWrapper} >
        <img className={classes.image} src={props.imageSrc} alt="" />
      </div>
    </Fragment>
  );

  const [dialog, showDialog, visible] = useConfirmDialog({
    ...props,
    content: newContent,
  });
  return [dialog, showDialog, visible];
};
